import React from 'react';
import { getUUID } from '../../utils/helpers';

const SwitchButton = ({label, 
    value=undefined, 
    onClick=()=>null, 
    si= 'Si', no= 'No', 
    children,customClass='',
    isRequired= true

}) => {

    return (       
         <div className="sg-input-switch mt-15">
            <label>{label} {children} </label>
            <div className={`sg-input-switch-option ${customClass}`}>
                {value === undefined && 
                    <input type="radio" name={label || getUUID()} className="sg-switch-validator" required={isRequired}/>
                }
                <button onClick={e => onClick(true)} type="button" className={value === true?'sg-switch-active':''}>{si}</button>
                <button onClick={e => onClick(false)} type="button" className={value=== false?'sg-switch-active':''}>{no}</button>
            </div>
        </div>
    );
}

export default SwitchButton